import { Component, OnInit, Input } from '@angular/core';
import { BookServiceService } from '../book-service.service';
import { book } from '../model/book';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
lval


branch:string[]=['MECHANICAL','COMPUTER_SCIENCE','ELECTRICAL','CIVIL'];
selectedbranch:string="";
semester:string[]=['SEMESTER1','SEMESTER2','SEMESTER3','SEMESTER4','SEMESTER5','SEMESTER6','SEMESTER7','SEMESTER8']
selectedSemester:string="";
bookList:book[];
bookListPresent:book[];
err:string

  constructor(private ser:BookServiceService,private fb:FormBuilder) { }


  ngOnInit(): void {
    this.bookList=null;
    this.lval=1
    this.getbook()
   
    

  }


  getbook(){
    this.ser.getbook().subscribe(res=>{
    
      this.bookList=res 
      console.log(this.bookList)
      this.bk()
    },error=>{this.err=error;
    });
    
  }
  selectedBook(){
   
 this.bookListPresent=this.bookList.filter(book=>{if(book.branch==this.selectedbranch){
  if(book.semester==this.selectedSemester) 
  {return true;}
  
  
  }
  else{return false;}})
    
  }

  bk(){
   
    this.bookListPresent=this.bookList 
  
  }

}
